import { Component, ViewChild } from '@angular/core';
import { of } from 'rxjs';
import { first } from 'rxjs/operators';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard';
import { ProgressComponent } from './progress.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionNameComponent } from './coonection.name';
import { ConnectionTriggerComponent } from './connection.trigger';
import { ConnectionActionComponent } from './connection.action';
import { AlertService, ConnectionService, AutomationService, AccountService } from '../_services';
import { AutomationsummeryComponent } from './automationsummery/automationsummery.component';
import { NgxSpinnerService } from "ngx-spinner";
import { Role, User } from '@app/_models/user';

@Component({
    templateUrl: 'newconnection.component.html',
    template: '<app-conntrigger></app-conntrigger>',

  })

export class NewConnectionComponent {
  uId: string;
  auid: string;
  code: string;
  URLFind: string;
  refereshTokenTrigger: string;
  refereshTokenAction: string;
  ConnectorID = null;
  redirect_uri: string;
  OpenAuthenticationDetail = null;
  userreturne: null;
  @ViewChild(ConnectionNameComponent) child: ConnectionNameComponent;

  @ViewChild(ConnectionTriggerComponent) triggerchild: ConnectionTriggerComponent;
  @ViewChild(ConnectionActionComponent) actionchild: ConnectionActionComponent;
  @ViewChild(AutomationsummeryComponent) summerychild: AutomationsummeryComponent;
  show: true;
  eventid: string;
  v: string;
  TriggerDetailforautomation: any;
  eventidaction: string;
  finalstep = false;
  formExitValidation = false;
  finaltoken = null;
  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden
  };

  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.dots,
    toolbarSettings: {
      toolbarExtraButtons: [
        {
          text: 'Finish', class: 'btn btn-info', event: () => {

            if (!this.finalstep) {
              this.alertService.warn('Please complete all steps for activating automation ', { keepAfterRouteChange: true });
              return;
            }
            try {
              this.eventid = this.triggerchild.form2.get('eventID').value;
            } catch (e) {
              this.eventid = '0';
            }
            try {
              this.eventidaction = this.actionchild.form2.get('eventID').value;
            } catch (e) {
              this.eventidaction = '0';
            }
            //if (!this.child.form.get('connectionName').value) {
            //  this.alertService.warn('Please complete all steps for activating automation ', { keepAfterRouteChange: true });
            //}else
            if (this.eventid == '0') {

              this.alertService.warn('Please complete all steps for activating automation ', { keepAfterRouteChange: true });
            } else if (this.eventidaction == '0') {

              this.alertService.warn('Please complete all steps for activating automation', { keepAfterRouteChange: true });
            } else {
              this.spinner.show();
              this.automationservice.getTriggerDetailsForAuotmationByRole(this.user.role,this.user.uId, this.auid, data => {
                    this.TriggerDetailforautomation = data;
                    let flg = '';
                    if (this.TriggerDetailforautomation.weebHookDetail!=null && this.TriggerDetailforautomation.weebHookDetail.webhookurl.includes("RequestTeam")) {
                      flg = 'TEAMS'
                    } else {
                      flg = 'SLACK'
                    }
                   

                    if (this.TriggerDetailforautomation.triggerDetailForAutomation.apiendpoint) {
                      this.automationservice.AutomationWebHookPost(this.TriggerDetailforautomation.triggerDetailForAutomation.apiendpoint, this.TriggerDetailforautomation.triggerDetailForAutomation.endpintusertoken, this.TriggerDetailforautomation.weebHookDetail.webhookurl + this.auid, flg)
                        .pipe(first())
                        .subscribe(
                          data2 => {
                            this.userreturne = data2;
                            if (this.userreturne) {
                              this.connectionservice.ActiveAutomation(this.auid,this.user.uId)
                                .pipe(first())
                                .subscribe(
                                  data2 => {
                                    try{
                                      if (this.user && this.user.role == Role.Client && this.user.name != null) {
                                        this.automationservice.mailOnAutomationComplete(this.auid).subscribe(x=>{});
                                      }
                                    }catch{}
                                    this.alertService.success(data2.message, { keepAfterRouteChange: true });
                                    this.spinner.hide();
                                    if (data2.isSuccess) {
                                      this.router.navigate(['./connection/automation/' + this.user.uId]);
                                    }
                                  },
                                  error => {
                                    this.spinner.hide();
                                  });
                            }
                            else {
                              this.alertService.error('Invalid User token', { keepAfterRouteChange: true });
                              this.spinner.hide();
                            }
                          },
                          error => {
                            if (error == "Bad Request")
                              error = "Invalid Authentication URL OR server is Down";
                            this.spinner.hide();
                            this.alertService.error(error);

                          }
                        )
                    }else{
                      this.spinner.hide();
                    }
              })
            }
          }
        }
      ],
      showPreviousButton:true,
    },
    anchorSettings: { enableAllAnchors: true, markDoneStep: true },
  };
  stepState=STEP_STATE.normal;
  user: User;
  constructor(private ngWizardService: NgWizardService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private connectionservice: ConnectionService,
    private automationservice: AutomationService,
    private spinner: NgxSpinnerService,
    private accountService: AccountService
  ) {
    this.uId = this.route.snapshot.params['uid'];
    this.auid = this.route.snapshot.params['auid'];
    this.accountService.user.subscribe(x =>{
      this.user = x
      if(this.user.role==Role.Client){
        this.config.selected=2;
        this.stepState=STEP_STATE.disabled;
      }
    });

    try {
      this.route.firstChild.params.subscribe(params => {
        //let auid = +params['auid'];
        this.auid = params['auid'];
      });
    } catch (e) {
    }
  }
  ngOnInit() {
    try {
      this.URLFind = this.router.url;
      try {
        this.route.firstChild.params.subscribe(params => {
          //let auid = +params['auid'];
          this.auid = params['auid'];
        });
      } catch (e) {

      }

      if (this.URLFind.includes('trigger')) {
        this.route.queryParams.subscribe(params => {
          this.refereshTokenTrigger = params['code'];
        });
        this.config.selected = 1;
      }
      else if (this.URLFind.includes('action')) {
        this.route.queryParams.subscribe(params => {
          this.refereshTokenAction = params['code'];
          this.config.selected = 2;

        });
      }
    } catch (e) {
      this.connectionservice.Error_Log(e)
        .pipe(first())
        .subscribe(ConnectorID => {

        });
    }

  }


  goNext(progress: ProgressComponent) {
    progress.next();
  }

  onStateChange(event) {
    console.log(event);
  }

  ngAfterViewInit() {


  }

  showPreviousStep(event?: Event) {

    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {

    this.ngWizardService.next();
  }

  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {

    this.ngWizardService.theme(theme);
  }

  stepChanged(args: StepChangedArgs) {
    this.ngWizardService.stepChanged();

    this.route.firstChild.params.subscribe(params => {
      //let auid = +params['auid'];
      this.auid = params['auid'];
    });
    if (args.step.index === 0) {
      this.finalstep = false;
      if (this.auid) {

      }
      if (args.direction === 'backward') {
        //  this.child.ngOnInit();
        this.router.navigate(['./connection/New/' + this.uId + '/name/edit/' + this.auid]);
      }

    } else if (args.step.index === 1) {

      if (args.direction === 'forward') {
        this.child.onSubmit();
      }
      // this.triggerchild.ngOnInit();
      this.finalstep = false;
      this.router.navigate(['./connection/New/' + this.uId + '/trigger/' + this.auid]);
    } else if (args.step.index === 2) {





      this.router.navigate(['./connection/New/' + this.uId + '/action/' + this.auid]);

      this.finalstep = false;
      this.config.toolbarSettings.showPreviousButton=true;
   

    }
    else if (args.step.index === 3) {
      this.router.navigate(['./connection/New/' + this.uId + '/summary/' + this.auid]);
      this.finalstep = true;
      this.summerychild.ngOnInit();
    }
  }

  isValidTypeBoolean: boolean = true;

  isValidFunctionReturnsBoolean(args: StepValidationArgs) {
    return true;
  }

  isValidFunctionReturnsObservable(args: StepValidationArgs) {
    this.formExitValidation = this.child.formExitValidation;
    if (this.formExitValidation) {
      return of(true);
    }
    else {
      return of(false);
    }


  }
  isValidFunctionReturnsObservable2(args: StepValidationArgs) {
    this.formExitValidation = this.triggerchild.formExitValidation;
    if (this.formExitValidation) {
      return of(true);
    }
    else {
      return of(false);
    }


  }
  isValidFunctionReturnsObservable3(args: StepValidationArgs) {
    this.formExitValidation = this.actionchild.formExitValidation;
    if (this.formExitValidation) {
      return of(true);
    }
    else {
      return of(false);
    }


  }
}
